// extracted by mini-css-extract-plugin
export default {"container":"qvPZzT","panel":"J6zp2G","panel-description":"iCnBFR"};